import { NgModule } from '@angular/core';
import { SelectComponent } from '@libs/ui/components/select/select.component';
import { TextareaComponent } from '@libs/ui/components/textarea/textarea.component';
import { InputComponent } from '@libs/ui/components/input';
import { PageLoaderComponent } from '@libs/ui/components/page-loader/page-loader.component';
import { CheckboxComponent } from '@libs/ui/components/checkbox/checkbox.component';
import { AvatarComponent } from '@libs/ui/components/avatar/avatar.component';

@NgModule({
  imports: [InputComponent, SelectComponent, TextareaComponent, PageLoaderComponent, CheckboxComponent, AvatarComponent],
  exports: [InputComponent, SelectComponent, TextareaComponent, PageLoaderComponent, CheckboxComponent, AvatarComponent],
})
export class ComponentsModule {}
